export default __webpack_public_path__ + "static/media/work-3.69116f8e.jpg";